// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2NU_x49hPEBOS0ce6hia-o","container":"_1gxqCTwkayuXv6V65KDfwN","fullScreenButton":"WAjabgpQjta2U9FXvxHp","item":"_1I5Tz_6HNc5EY8rf7sn0G2","galleryWrapper":"_2adVnc7Dh37YSsz_X5amHt","image":"_1i7cfwAibOIPuyH_YLuSA_","quantityTitle":"_1_muBoRLVGzTGgyBKC_myb","priceLine":"_3_wBBv7WPZ6LlxWyzGbzZr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/ProjectInlineGallery/ProjectInlineGallery.scss
// module id = 1717
// module chunks = 0